import React from "react";
import { newsImageData } from "../../assest/imgPaths";

const HerroSection = () => {
  /* const [scrollY, setScrollY] = useState(0); */
  /*   const [isLargeScreen, setIsLargeScreen] = useState(false); */

  // Handle scroll event for parallax effect

  /* useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY); // Capture the vertical scroll position
    };

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 950);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []); */

  return (
    <div className="bg-black relative overflow-hidden h-[calc(100vh*0.6)] xl:h-[calc(100vh*1)] w-full pt-14">
      <img
        src={newsImageData.herroLargeScreen}
        alt="K2 invest green Home banner"
        className="opacity-50 inline-block max-w-full w-full h-[60vh] xl:h-[100vh] text-center align-middle object-cover"
      />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 xl:-translate-y-1/2 flex flex-col items-center justify-center gap-3 text-xl xl:text-5xl text-primary-bg-light tracking-wider italic text-center">
        <span>შენი ოჯახის ისტორია</span>
        <strong className="text-primary-orange font-gilroy text-3xl xl:text-6xl tracking-wider">
          {" "}
          იწყება აქ!
        </strong>
      </div>
    </div>
  );
};

export default HerroSection;
